module.exports = __webpack_public_path__ + "img/under-maintenance.ba006d06.svg";